module.exports = __webpack_public_path__ + "img/画板 12.a741e4cd.jpg";